<template>
  <div class="activity-detail">
    <content-panel>
      <div class="infoBox">
        <div class="information">
          <p class="titleStyle">活动信息</p>
          <el-row>
            <el-col :span="8">
              <span>活动ID：</span>
              <span>{{ detail.activityId }}</span>
            </el-col>
            <el-col :span="8">
              <span>活动名称：</span>
              <span>{{ detail.activityName }}</span>
            </el-col>
            <el-col :span="8">
              <span>使用模板：</span>
              <span>{{ detail.tmpName }}</span>
            </el-col>
          </el-row>
        </div>

        <div class="divder"></div>
        <div class="information">
          <p class="titleStyle">创建信息</p>
          <el-row>
            <el-col :span="8">
              <span>创建人：</span>
              <span>{{ detail.createdUserName }}</span>
            </el-col>
            <el-col :span="8">
              <span>创建时间：</span>
              <span>{{ detail.createdTime | dateFormat }}</span>
            </el-col>
            <el-col :span="8">
              <span>截至时间：</span>
              <span>{{ detail.endTime | dateFormat }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="information">
          <p class="titleStyle">组件信息</p>
          <el-button type="primary" @click="isShowCpnsInfoDialog = true">点击查看</el-button>
        </div>
      </div>
      <div class="divder"></div>
      <table-panel ref="tablePanel0">
        <template v-slot:header-left>
          <el-radio-group
            v-model="tabType"
            @change="changeData"
            size="mini"
          >
            <el-radio-button label="store">门店数据</el-radio-button>
            <el-radio-button label="signUp" v-if="detail.signUpModules && detail.signUpModules.length">报名数据</el-radio-button>
            <el-radio-button label="luckdraw" v-if="detail.lotteryModules && detail.lotteryModules.length">抽奖数据</el-radio-button>
            <el-radio-button label="seckill" v-if="detail && detail.skillDetail">秒杀数据</el-radio-button>
            <el-radio-button label="answers" v-if="detail && detail.questionBaseDetail">问答数据</el-radio-button>
            <el-radio-button label="group" v-if="detail && detail.groupBuyingDetailVO">拼团数据</el-radio-button>
            <el-radio-button label="drawLots" v-if="detail && detail.drawDetailVO">求签数据</el-radio-button>
            <el-radio-button label="countMoney" v-if="detail && detail.countMoneyDetailVO">红包挑战赛数据</el-radio-button>
            <el-radio-button label="coupon">优惠券数据</el-radio-button>
          </el-radio-group>
        </template>
        <template v-slot:header-right>
          <el-button type="primary" @click="exportList">导出</el-button>
        </template>
        <!-- 门店数据 -->
        <template v-if="tabType === 'store'">
          <my-table isHeight :tableData="tableData" :propList="storePropList" :loading="loading">
            <template #viewEmployees="scope">
              <el-button type="text" size="small" @click="viewEmployees(scope.row)">查看参与职员</el-button>
            </template>
          </my-table>
        </template>
        <!-- 报名数据 -->
        <template v-if="tabType === 'signUp'">
          <my-table isHeight :tableData="tableData" :propList="signUpPropList" :loading="loading">
            <template #status="scope">
              {{ scope.row.signupStatus | signupStatus }}
            </template>
            <template #shareEmployees="scope">
              <span style="color: #0BB78E;cursor: pointer;" @click="viewingPersonnel(scope.row, 1)">
                {{ scope.row.staffName }}
              </span>
            </template>
            <template #verificationPersonnel="scope">
              <span style="color: #0BB78E;cursor: pointer;" @click="viewingPersonnel(scope.row, 2)">
                {{ scope.row.verificationStaffName }}
              </span>
            </template>
          </my-table>
        </template>
        <!-- 抽奖数据 -->
        <template v-if="tabType === 'luckdraw'">
          <my-table isHeight :tableData="tableData" :loading="loading" :propList="luckdrawPropList">
            <template #verificationPersonnel="scope">
              <span style="color: #0BB78E;cursor: pointer;" @click="draw(scope.row, 1)">
                {{ scope.row.exchangeUser }}
              </span>
            </template>
          </my-table>
        </template>
        <!-- 秒杀组件 -->
        <template v-if="tabType === 'seckill'">
          <my-table isHeight :tableData="tableData" :loading="loading" :propList="seckillPropList"></my-table>
        </template>
         <!-- 问答数据 -->
        <template v-if="tabType === 'answers'">
          <my-table isHeight :tableData="tableData" :loading="loading" :propList="answersPropList"></my-table>
        </template>
        <!-- 拼团数据 -->
        <template v-if="tabType === 'group'">
          <my-table isHeight :tableData="tableData" :loading="loading" :propList="groupPropList"></my-table>
        </template>
        <!-- 求签数据 -->
        <template v-if="tabType === 'drawLots'">
          <my-table isHeight :tableData="tableData" :loading="loading" :propList="drawLotsData"></my-table>
        </template>
        <!-- 红包挑战赛数据 -->
        <template v-if="tabType === 'countMoney'">
          <my-table isHeight :tableData="tableData" :propList="countMoneyData" @sortChange="sortChange" :loading="loading">
            <template #handle="scope">
              <el-button type="text" size="small" @click="checkPrizeDetail(scope.row)">查看奖品</el-button>
            </template>
          </my-table>
        </template>
        <!-- 优惠券数据 -->
        <template v-if="tabType === 'coupon'">
          <my-table isHeight :tableData="tableData" :propList="couponTabData" @sortChange="sortChange" :loading="loading"></my-table>
        </template>

        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
      
      <clerk-dialog 
        :visible.sync="isShowViewEmployees" 
        v-if="isShowViewEmployees" 
        :activityId="activityId" 
        :rowData="rowData" 
      />
      <viewing-personnel 
        :visible.sync="isViewingPersonnel" 
        v-if="isViewingPersonnel" 
        :userId="userId" 
      />
      <count-money-dialog 
        :isCountMoneyDialog.sync="isCountMoneyDialog" 
        :activityId="activityId" 
        :participationId="participationId" 
      />
      <cpns-info-dialog 
        :isShowCpnsInfoDialog.sync="isShowCpnsInfoDialog"
        :detail="detail"
      />
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import myTable from '@/components/my-table';
import viewingPersonnel from '@/views/data-report/viewingPersonnel.vue'
import clerkDialog from './clerk-dialog'
import countMoneyDialog from './components/count-money-dialog'
import cpnsInfoDialog from './components/cpns-info-dialog'
import {
  storePropList,
  signUpPropList,
  luckdrawPropList,
  seckillPropList,
  awardsArrPropList,
  answersPropList,
  groupPropList,
  drawLotsData,
  countMoneyData,
  couponTabData
} from './config'
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    myTable,
    clerkDialog,
    viewingPersonnel,
    countMoneyDialog,
    cpnsInfoDialog
  },
  data() {
    return {
      maxHeight: window.innerHeight - 520,
      activityId: null,
      loading: false,
      detail: {},
      tabType: "store",
      tableData: [],
      storePropList,
      signUpPropList,
      luckdrawPropList,
      seckillPropList,
      answersPropList,
      groupPropList,
      drawLotsData,
      countMoneyData,
      propList: awardsArrPropList,
      couponTabData,
      pageNum: 1,
      total: 0,
      pageSize: 20,
      isShowViewEmployees: false,
      isViewingPersonnel: false,
      isCountMoneyDialog: false,
      rowData: {},
      viewingType: 1,
      userId: "1",
      participationId: null,
      isShowCpnsInfoDialog: false
    };
    
  },
  mounted() {
    this.activityId = this.$route.query.activityId;
    this.getActivityDetail();
    this.getList();
  },
  methods: {
    getActivityDetail() {
      this.$api.ActivityManagement.activityDetail(this.activityId)
        .then((res) => {
          if (res.success) {
            this.detail = res.data;
          }
        });
    },
    changeData() {
      this.tableData = []
      this.pageNum = 1
      this.total = 0
      this.pageSize = 20
      this.getList()
    },
    getList(sortParmames={}) {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          activityId: this.activityId,
          ...sortParmames
        },
      };
      let requestMap = {
        store: 'activityStoreInfo',
        signUp: 'activitySignUpInfo',
        luckdraw: 'activityLotteryRecord',
        seckill: 'getActivitySeckillOrder',
        answers: 'getActivityQuestionAnswerLog',
        group: 'getGroupBuyingOrderList',
        drawLots: 'getDrawList',
        countMoney: 'getActivityCountMoneyRecord',
        coupon: 'getcouponTabPages',
      }
      this.$api.ActivityManagement[requestMap[this.tabType]](params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        }).finally(() => {
          this.loading = false;
        });
    },
    // 排序
    sortChange(e) {
      const { prop,order} = e
      const sortParmames = {
        sortOrder: prop === "allRankNo" ? 1 : 2,
        sortord: order === 'ascending' ? 1 : 2
      }
      this.getList(sortParmames)
    },
    viewEmployees(row) {
      this.rowData = {...row},
      this.isShowViewEmployees = true
    },
    viewingPersonnel(row,type) {
      this.userId = type === 1 ? row.h5UserId : row.verificationUserId
      this.isViewingPersonnel = true
    },
    draw(row) {
      this.userId = row.exchangeUserId
      this.isViewingPersonnel = true
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    exportList() {
      let params = {
        activityId: this.activityId,
        isDecrypt: this.tabType == 'countMoney' ? true : false
      };
      let map = {
        store: 'activityStoreInfo',
        signUp: 'activitySignUpInfo',
        luckdraw: 'getActivityLotteryRecord',
        seckill: 'getActivitySeckillOrder',
        answers: 'getActivityQuestionAnswerLog',
        group: 'getGroupBuyingOrderList',
        drawLots: 'getDrawList',
        countMoney: 'getActivityCountMoneyRecord',
        coupon: 'queryCouponOrderList',
      }
      this.$api.common.doExport(map[this.tabType], params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
    diaLogExportList(type) {
      let params = {
        activityId: this.activityId,
        isDecrypt: true
      };
      this.$api.common.doExport(type, params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
    checkPrizeDetail(row) {
      this.participationId = row.id
      this.isCountMoneyDialog = true
    }
  },
  filters: {
    signupStatus(value) {
      const obj = {
        1: "已报名",
        2: "已核销",
        3: "已退款",
        4: "报名失败",
        5: "退款失败",
        6: "退款中",
      };
      return obj[value] || "";
    },
    boolSuccess(value) {
      return value == 'sucess' ? '成功' : '失败'
    }
  },
};
</script>

<style lang="stylus" scoped>
.activity-detail {
  .divder {
    width: 100%;
    height: 1px;
    background: #ccc;
    margin-bottom: 10px;
  }
  .information {
    margin-bottom: 10px;
    .title {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
  .titleStyle{
    font-weight:bold;
    font-size: 15px
  }
  .infoBox{
    width:100%;
    height: 225px;
    overflow: auto
  }
}

</style>
